
import Dropzone from "dropzone";
import Cropper from 'cropperjs'; 
import 'cropperjs/dist/cropper.css';

export default {
  name: 'ImageCropper',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "What happens when an image is cropped?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "When cropping an image online, you will adjust the photo's edges and remove unnecessary parts. This operation also changes the image size and aspect ratio. A compelling image crop tool can draw the viewer's attention to your subject."
          }
      },{
          "@type": "Question",
          "name": "How do you crop an image?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "To use the crop image tool, here are the steps you need to do: Upload images by drop. Use drag to select where to crop the image. This position can be the side edges or the top and bottom edges. Press the Shift key, and the image crop tool automatically removes the want-to-crop area you locate. Now, you can change your crop image area using the clipping handles."
          }
      },{
          "@type": "Question",
          "name": "How do you make an image cropper?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Most photo editing software today supports image cropping tools. You can also use an online cropping tool. It is not difficult for you to crop images online and achieve the desired effect."
          }
      },{
          "@type": "Question",
          "name": "How do you use the freehand image cropper?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "To use the freehand image cropper, here's all you need to do: With a few clicks, you can upload images. Click on the image to perform operations that define the want-to-crop area. To add a cut point, select Ctrl +; to take a point automatically deleted, select Shift +. To remove the object, select Ctrl + Shift + key combination."
          }
      },{
          "@type": "Question",
          "name": "How do I crop a JPG image?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Look for the JPG cropper tool's photo toolkit. Then go to the format section. In the exact size section, select the Crop image online option. You can choose the available aspect ratio, enter the desired frame parameters, and press crop."
          }
      }]
    };
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        form: this.$vform({ })
    };
  },
  mounted() {

        Dropzone.autoDiscover = false;

        let vm = this;

        var uploadedImageType = 'image/jpeg', uploadedImageName = 'image.jpg';

        var errors = false;

        var myDropzone = new Dropzone(".dropzone", { 
           maxFilesize: 5,
           autoProcessQueue: false,
           maxFiles:1,
           acceptedFiles: "image/*",
           previewsContainer: false,
           thumbnailWidth: null,
           thumbnailHeight: null,
           addedfile: function (file) {
                errors = false;
                if (this.files.length > 1) {
                  this.removeFile(this.files[0]);
                }
           },
           error: function (file, message) {
                this.removeFile(file);
                alert(message);
                errors = true;
           },
           thumbnail: function(file, dataUrl) {

                if(errors) return;
                if (/^image\/\w+/.test(file.type)) {
                    uploadedImageName = file.name;
                    uploadedImageType = file.type;                  
                }

                // start file reader
                let result = document.querySelector('#preview-image'), cropper = '';
                const reader = new FileReader();
                reader.onload = (e)=> {
                    // create new image
                    let img          = document.createElement('img');
                    img.id           = 'image';
                    img.className    = 'img-fluid';
                    img.src          = dataUrl;
                    result.innerHTML = '';
                    result.appendChild(img);
                    initCropper( uploadedImageName, uploadedImageType );

                };
                reader.readAsDataURL(file);
           }
        });

        initCropper( uploadedImageName, uploadedImageType );

        function initCropper( fileName, fileType ){

            // init cropper
            var cropper = window.Cropper;
            var URL     = window.URL || window.webkitURL;
            var image   = document.querySelector('#image');

            var options = {
                aspectRatio: 16 / 9,
                background: false,
                viewMode: 3
            };

            cropper = new Cropper(image, options);

            // Methods
            document.querySelector('.crop_image').onclick = function(event) {
                var e      = event || window.event;
                var target = e.target || e.srcElement;
                var cropped;
                var result;
                var data;

                while (target !== this) {
                  if (target.getAttribute('data-method')) {
                    break;
                  }

                  target = target.parentNode;
                }

                data = {
                  method: target.getAttribute('data-method'),
                  option: target.getAttribute('data-option') || undefined
                };

                cropped = cropper.cropped;

                if (data.method) {

                  result = cropper[data.method](data.option);

                  switch (data.method) {

                    case 'getCroppedCanvas':

                        if (result) {

                            result.toBlob(function(blob) {

                                vm.onImageCropper(URL.createObjectURL(blob), fileName);

                            }, fileType)
                            
                        }

                      break;

                  }

                }
            };

            // Ratio toggles
            document.querySelector('.ratio-toggles').onchange = function(event) {
                var e      = event || window.event;
                var target = e.target || e.srcElement;

                if (!cropper) {
                  return;
                }

                options[target.name] = target.value;
                cropper.destroy();
                cropper = new Cropper(image, options);
            };
            
        }
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onImageCropper(blobURL, fileName) {

        jQuery('.download-image').attr( 'href',  blobURL);

        jQuery('.preview-download-image').attr('src', blobURL);

        jQuery('.download-image').attr('data-filename', fileName);

        jQuery('#modalPreviewDownloadImage').modal('show');
    },
    onDownloadImage( image ) {
        const link   = document.createElement('a');
        var filename = image.srcElement.dataset.filename;
        link.href    = image.srcElement.href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
    //
  }
}
